import {addQuery} from '@yandex-delivery/utils'

import type {CargoCrmRepository, CargoCrmRepositoryParams} from './types'

function createCargoCrmRepository(params: CargoCrmRepositoryParams): CargoCrmRepository {
  const {fetch} = params

  return {
    fetchState(body) {
      return fetch({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        url: 'cargo-crm/flow/phoenix/state',
        body,
      })
    },
    fetchTicketInit(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery('cargo-crm/flow/phoenix/ticket/init', query),
        body,
      })
    },
    fetchTicketState(query) {
      return fetch({
        method: 'GET',
        url: addQuery('cargo-crm/flow/phoenix/ticket/state', query),
      })
    },
    fetchFillCompanyInfo(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery('cargo-crm/flow/phoenix/ticket/fill-company-info', query),
        body,
      })
    },
    fetchCompanySuggest(body) {
      return fetch({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        url: 'cargo-crm/flow/phoenix/helpers/company/suggest',
        body,
      })
    },
    fetchFillOfferInfo(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery('cargo-crm/flow/phoenix/ticket/fill-offer-info', query),
        body,
      })
    },
    fetchSendEdoConfirmationDocument(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery('cargo-crm/flow/add-balance/ticket/send-edo-confirmation-document', query),
        body,
      })
    },
    fetchCheckOfferInfo(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery('cargo-crm/functions/by-flow/check-offer-info', query),
        body: {offer_info_form: body},
      })
    },
    fetchBalanceTicketInit() {
      return fetch({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        url: 'cargo-crm/flow/add-balance/ticket/init',
      })
    },
  }
}

export {createCargoCrmRepository}
